import { addDays, endOfMonth, isAfter, startOfWeek } from 'date-fns'

export type Week = {
  /** 해당 월 안에서의 순번 (1부터 시작, ISO 8601 전체 연도 주차와 다름) */
  weekNumber: number
  startDate: Date
  endDate: Date
}

export function getMonthWeeks(year: number, month: number): Week[] {
  // ISO 8601 기준: 첫 번째 목요일이 속한 주를 1주차로 삼음
  let firstThursday = new Date(year, month - 1, 1)
  while (firstThursday.getDay() !== 4) {
    firstThursday = addDays(firstThursday, 1)
  }

  const week1Start = startOfWeek(firstThursday, { weekStartsOn: 1 })
  const monthLastDay = endOfMonth(new Date(year, month - 1, 1))

  const weeks: Week[] = []
  let weekStart = week1Start
  let weekNumber = 1

  while (!isAfter(weekStart, monthLastDay)) {
    weeks.push({
      weekNumber,
      startDate: weekStart,
      endDate: addDays(weekStart, 6),
    })
    weekStart = addDays(weekStart, 7)
    weekNumber++
  }

  return weeks
}
